module.exports = __webpack_public_path__ + "static/Elliot-fee6a6c2095b8f93879b34a1a64deb3e.png";